export { defaultProps, LikertQuestion } from './LikertQuestion'
